import { TrendingDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Price } from '~/utils/money';
import { moneyOrDash } from './quoteDisplay';
import type { PriceKind } from './splitAwardGridTypes';

const LOWEST_PRICE_CLASS: Record<PriceKind, string> = {
  pickup: 'bg-prim-100 text-prim-700',
  delivery: 'bg-success-100 text-success-700',
};

export function OfferedPrice({
  itemId,
  price,
  lowestAmount,
  kind,
}: Readonly<{
  itemId: string;
  price: Price | null | undefined;
  lowestAmount: number | null;
  kind: PriceKind;
}>) {
  const { t } = useTranslation('rfq-view');
  const lowestLabel = t('rfq_view.lowest_price_label');

  if (price == null || lowestAmount == null || price.amount !== lowestAmount) {
    return <>{moneyOrDash(price)}</>;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded px-1 font-semibold ${LOWEST_PRICE_CLASS[kind]}`}
      data-testid={`lowest-${kind}-price-${itemId}`}
      title={lowestLabel}
    >
      {moneyOrDash(price)}
      <TrendingDown className="h-3 w-3" aria-hidden="true" />
      <span className="sr-only">{lowestLabel}</span>
    </span>
  );
}
